<template>
	<div>
		<slot
			:saveExercise="saveExercise"
			:refItems="refItems"
			:exercise="exercise"
			:doc="doc"
		></slot>
	</div>
</template>

<script>
const fb = require('@/firebaseConfig.js');
import { mapState } from 'vuex';
// import lodash from "lodash";

export default {
	name: 'ExerciseLogic',
	data() {
		return {
			componentReady: false,
			intervalId: null,
			exercise: null,
			ex: null,
			refItems: null,
			dialog: false,
		};
	},
	beforeRouteUpdate(to, from, next) {
		this.init();
		next();
	},
	mounted() {
		this.init();
	},
	props: {
		exCollection: String,
		refCollection: String,
		doc: Object,
		shared: {
			type: Boolean,
			default: false,
		},
		projectShared: {
			type: Boolean,
			default: false,
		},
		pid: {
			type: Boolean,
			default: false,
		},
		iterative: {
			type: Boolean,
			default: false,
		},
		synced: {
			type: Boolean,
			default: true,
		},
		saveState: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		...mapState([
			'userProfile',
			'currentUser',
			'currentProject',
			'currentProjectModel',
		]),
	},
	watch: {
		saveState(val) {
			if (val) {
				this.saveExercise(false);
			}
		},
	},
	methods: {
		init() {
			let vm = this;
			clearInterval(this.intervalId);
			this.intervalId = null;
			this.intervalId = setInterval(function() {
				vm.checkStatus();
			}, 300);
		},
		checkStatus() {
			if (this.currentProjectModel && this.currentProjectModel.id) {
				this.componentReady = true;
				this.$emit('ready');
				clearInterval(this.intervalId);
				if (this.refCollection) {
					if (this.synced) {
						this.prePopulate();
					} else {
						this.prePopulateOnce();
					}
				} else {
					this.getExercise();
				}
			}
		},
		prePopulate() {
			console.log('get reference');
			let ref;
			if (this.pid) {
				ref = fb[this.refCollection].where(
					'pid',
					'==',
					this.currentProjectModel.id
				);
			} else {
				ref = fb[this.refCollection];
			}
			ref.onSnapshot((querySnapshot) => {
				let items = [];
				let mode = '';
				if (
					querySnapshot.docChanges().length != querySnapshot.docs.length &&
					querySnapshot.docChanges()[0].type == 'added'
				) {
					mode = 'added';
					let post = querySnapshot.docChanges()[0].doc.data();
					items.push(post);
				} else if (
					querySnapshot.docChanges().length &&
					querySnapshot.docChanges()[0].type == 'modified'
				) {
					mode = 'modified';
					querySnapshot.forEach((doc) => {
						let post = doc.data();
						items.push(post);
					});
				} else {
					mode = 'initial';
					console.log(querySnapshot);
					querySnapshot.forEach((doc) => {
						let post = doc.data();
						items.push(post);
					});
				}
				if (mode == 'modified') {
					this.$emit('modifyRef', items);
				} else if (mode == 'added') {
					this.$emit('addRef', items);
				} else {
					this.$emit('loadedRef', items);
				}
				this.getExercise();
			});
		},
		prePopulateOnce() {
			console.log('get reference material once', this.currentProjectModel.id);
			let ref = fb[this.refCollection].where(
				'pid',
				'==',
				this.currentProjectModel.id
			);
			ref
				.get()
				.then((result) => {
					let items = [];
					result.forEach((doc) => {
						let post = doc.data();
						items.push(post);
					});
					if (items) {
						this.$emit('loadedRef', items);
					}
				})
				.catch(function() {});
			this.getExercise();
		},
		// getExercise() {
		//   let uid = this.currentUser.uid;
		//   let ref = fb[this.exCollection]
		//     .where("uid", "==", uid)
		//     .where("pid", "==", this.currentProjectModel.id);
		//   ref.onSnapshot((querySnapshot) => {
		//     let items = [];
		//     let mode = "";
		//     if (
		//       querySnapshot.docChanges().length != querySnapshot.docs.length &&
		//       querySnapshot.docChanges()[0].type == "added"
		//     ) {
		//       mode = "added";
		//       let post = querySnapshot.docChanges()[0].doc.data();
		//       items.push(post);
		//     } else if (
		//       querySnapshot.docChanges().length &&
		//       querySnapshot.docChanges()[0].type == "modified"
		//     ) {
		//       mode = "modified";
		//       querySnapshot.forEach((doc) => {
		//         let post = doc.data();
		//         items.push(post);
		//       });
		//     } else {
		//       mode = "initial";
		//       querySnapshot.forEach((doc) => {
		//         let post = doc.data();
		//         items.push(post);
		//       });
		//       this.exercise = items[0];
		//       this.$emit("loadedEx", items[0]);
		//     }
		//     if (mode == "modified") {
		//       this.$emit("modifyEx", items);
		//     } else if (mode == "added") {
		//       this.$emit("addEx", items);
		//     } else {
		//       this.$emit("loadedEx", this.exercise);
		//     }
		//   });
		// },
		getExercise() {
			console.log('get exercise');
			let ref;
			if (this.shared) {
				ref = fb[this.exCollection]
					.where('uid', '==', 'shared')
					.where('pid', '==', this.currentProjectModel.id);
			} else if (this.projectShared) {
				ref = fb[this.exCollection].where(
					'pid',
					'==',
					this.currentProjectModel.id
				);
			} else {
				const uid = this.currentUser.uid;
				ref = fb[this.exCollection]
					.where('uid', '==', uid)
					.where('pid', '==', this.currentProjectModel.id);
			}
			ref.onSnapshot((querySnapshot) => {
				let items = [];
				querySnapshot.forEach((docs) => {
					let doc = docs.data();
					items.push(doc);
				});
				if (items.length) {
					this.exercise = items[0];
					this.$emit('loadedEx', items);
				} else {
					this.$emit('loadedEx', null);
				}
			});
		},
		saveExercise(notify) {
			// check if exercise exists
			let ref;
			let uid = this.shared ? 'shared' : this.currentUser.uid;
			// alert(this.exercise.id);
			// let vm = this;
			if (this.exercise == null) {
				console.log('no exercise');
				ref = fb[this.exCollection].doc();
			} else {
				console.log('has exercise', this.exercise.id);
				ref = fb[this.exCollection].doc(this.exercise.id);
			}
			ref
				.set({
					updatedOn: new Date(),
					id: ref.id,
					uid: uid,
					pid: this.currentProjectModel.id,
					doc: this.doc,
				})
				.then(() => {
					// this.exercise = this.doc;
					if (notify) {
						this.$emit('saved');
					} else {
						this.$emit('savedNext');
					}
				})
				.catch((error) => {
					alert('Error adding document: ', error);
				});
		},
	},
};
</script>
